export const PERMS = {
    READ: 'report_trailer_costs.read',
    EXPORT: 'report_trailer_costs.export',
}
